<script>
export default {
  name: 'Accordion',
  props: {
    itemKey: {
      type: Number
    },
    title: {
      type: String
    },
    content: {
      type: String
    },
    image: {
      type: String
    },
    order: {
      type: Number
    }
  },
  data: () => ({
    isActive: false
  }),
  methods: {
    toggleActive() {
      this.isActive = !this.isActive;
    }
  }
};
</script>

<template>
  <div
    :class="{
      accordion: true,
      active: this.isActive
    }"
  >
    <h3 @click="toggleActive" class="heading">
      <button :id="'accordion-control-' + itemKey" type="button">
        {{ title }}
        <span class="icon-container">
          <vue-fontawesome
            :class="{
              icon: true,
              spun: !this.isActive
            }"
            :icon="['far', isActive ? 'minus' : 'plus']"
          />
        </span>
      </button>
    </h3>
    <div
      :id="'accordion-panel-' + itemKey"
      class="collapsible"
      v-show="isActive"
    >
      <div class="content-container">
        <div
          class="is-half image-wrapper"
          :style="{
            order: order,
            padding: order > 0 ? '0 0 0 3rem' : '0 3rem 0 0'
          }"
        >
          <img
            :src="
              `https://static.porscheautoinsurance.com/images/homepage/${image}`
            "
            alt
          />
        </div>
        <div class="accordion-content is-half" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
div.accordion {
  background-color: $base;
  border-bottom: solid 1px $gray1;
}
h3 {
  font-family: $family-sans-serif;

  &.heading {
    margin-bottom: 0.25rem;
  }
}
button {
  background: transparent;
  position: relative;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  width: 100%;
  border: none;
  //border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;

  &::before {
    content: '';
    position: absolute;
    border-radius: 4px;
    inset: 6px -4px;
  }
  &:hover {
    cursor: pointer;
    &::before {
      background-color: #9495982e;
      transition: background-color 0.25s cubic-bezier(0.25, 0.1, 0.25, 1);
    }
  }
}
div.content-container {
  width: 100%;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: -4px;
  padding: 4px;
  @media (max-width: 720px) {
    flex-wrap: wrap;
  }
}
div.image-wrapper {
  max-width: 50%;
  min-width: 400px;
  img {
    border-radius: 12px;
  }
}
div.accordion-content {
  //padding-left: 3rem;
}
span.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(2.125ex + 6px);
  height: calc(2.125ex + 6px);
}
.icon {
  transition: transform 0.25s cubic-bezier(0.25, 0.1, 0.25, 1);
  filter: invert(3%) sepia(7%) saturate(2930%) hue-rotate(188deg)
    brightness(91%) contrast(103%);
  font-size: 0.75rem;
  animation: 1ms rerender-light-primary;
  pointer-events: none;
  margin: 0;
}
.icon.spun {
  transform: rotate3d(0, 0, 1, 90deg);
}
</style>
